import React, { useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import { VirtualScroller } from "primereact/virtualscroller";
import NotFound from "../../../../Utils/NotFound/NotFound";
import MessageCard from "./MessageCard";
import TopCard from "./TopCard/TopCard";

const backend = await new Backend().init();

export default function Message() {
  const windowSize = useSize();

  const userType = Number(localStorage.getItem("user_type") || 7);

  const [message, setMessage] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadMessage();
  }, []);

  const loadMessage = (a, b) => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    backend.message(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setMessage(r.message);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div
      key={message}
      style={{
        width: windowSize[0],
        height: windowSize[1] - 110,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {userType === 1 && <TopCard reload={loadMessage} userType={userType} />}

      {loading ? (
        <div className="loadingContainer">
          <Loading height={windowSize[1] - 110} />
        </div>
      ) : message.length > 0 ? (
        <VirtualScroller
          style={{
            width: windowSize[0],
            height: windowSize[1] - 110,
          }}
          items={message}
          itemSize={50}
          itemTemplate={(item, index) => {
            return (
              <MessageCard
                userType={userType}
                key={item.id}
                index={index}
                item={item}
                reload={loadMessage}
              />
            );
          }}
        />
      ) : (
        <NotFound height={windowSize[1] - 110} title={"Nothing here"} subtext={"No Message Found."} />
      )}
    </div>
  );
}
